import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CategorySlider from "../../../CategorySlider";


/* ================= UTTAR PRADESH CITY DATA ================= */

const uttarPradeshCities = [
  { slug: "lucknow", city: "Lucknow", state: "Uttar Pradesh" },
  { slug: "noida", city: "Noida", state: "Uttar Pradesh" },
  { slug: "ghaziabad", city: "Ghaziabad", state: "Uttar Pradesh" },
  { slug: "kanpur", city: "Kanpur", state: "Uttar Pradesh" },
  { slug: "agra", city: "Agra", state: "Uttar Pradesh" }
];

const UttarPradesh = () => {
  const { city } = useParams();

  /* ================= STATE PAGE ================= */
  if (!city) {
    return (
      <div style={{ marginTop: "90px", padding: "25px", lineHeight: "1.8" }}>
        <h1>Sex Toys Delivery in Uttar Pradesh</h1>

        <p>
          Buy premium <strong>sex toys in Uttar Pradesh</strong> with fast,
          safe, and discreet delivery. LushDesire is a trusted Indian adult
          wellness store offering genuine products for men, women, and couples
          across Uttar Pradesh.
        </p>

        <h2>Cities We Serve in Uttar Pradesh</h2>

        <ul>
          {uttarPradeshCities.map((c) => (
            <li key={c.slug}>
              <Link to={`/sex-toys-delivery/uttar-pradesh/${c.slug}`}>
                Sex Toys in {c.city}
              </Link>
            </li>
          ))}
        </ul>

        <h3>Why Buy Sex Toys Online in Uttar Pradesh?</h3>
        <p>
          Online shopping for adult wellness products is now safe and private.
          We focus on quality, confidentiality, and reliable delivery across
          both metro and non-metro cities of Uttar Pradesh.
        </p>
      </div>
    );
  }

  /* ================= CITY PAGE ================= */
  const cityData = uttarPradeshCities.find((c) => c.slug === city);

  if (!cityData) {
    return (
      <div style={{  backgroundColor: "#FFF5F5", marginTop: "120px", padding: "30px" }}>
        <h2>City not found</h2>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Sex Toys in {cityData.city} | Discreet Delivery in Uttar Pradesh
        </title>
        <meta
          name="description"
          content={`Buy sex toys in ${cityData.city} with fast & discreet delivery. Premium adult toys and couples wellness products available across Uttar Pradesh.`}
        />
      </Helmet>
<CategorySlider />

      <div style={{  backgroundColor: "#FFF5F5",  padding: "25px", lineHeight: "1.8" }}>
        {/* H1 */}
        <h1>Sex Toys in {cityData.city} – Private & Safe Delivery</h1>

        <p>
          Looking to buy <strong>sex toys in {cityData.city}</strong>? LushDesire
          offers premium, body-safe adult toys with 100% discreet packaging and
          fast delivery across Uttar Pradesh.
        </p>

        {/* H2 */}
        <h2>Buy Sex Toys Online in {cityData.city}</h2>
        <p>
          Buying sex toys online in {cityData.city} is now convenient and
          confidential. Our collection includes carefully selected wellness
          products designed to improve comfort, confidence, and intimacy.
        </p>

        {/* H3 */}
        <h3>Popular Sex Toys Available in {cityData.city}</h3>
        <ul>
          <li>✔ Vibrators & Bullet Massagers</li>
          <li>✔ Dildos & Realistic Toys</li>
          <li>✔ Couples Sex Toys</li>
          <li>✔ Male Masturbators</li>
          <li>✔ Female Pleasure & Wellness Products</li>
        </ul>

        {/* H3 */}
        <h3>Why Choose LushDesire in {cityData.city}?</h3>
        <ul>
          <li>✔ 100% Discreet & Plain Packaging</li>
          <li>✔ Fast Delivery in {cityData.city}</li>
          <li>✔ Cash on Delivery Available</li>
          <li>✔ Secure Online Payments</li>
          <li>✔ Trusted Indian Adult Store</li>
        </ul>

        {/* H4 */}
        <h4>Discreet Sex Toys Delivery Across Uttar Pradesh</h4>
        <p>
          All orders are shipped in plain boxes with no adult branding. We
          deliver safely across {cityData.city}, Lucknow, Noida, Ghaziabad,
          Kanpur, Agra, and nearby areas.
        </p>

        {/* H4 */}
        <h4>Who Can Buy Sex Toys from LushDesire?</h4>
        <p>
          Our products are suitable for beginners and experienced users alike.
          Whether you are shopping solo or as a couple, we ensure privacy,
          authenticity, and trusted service.
        </p>

        {/* H5 */}
        <h5>Frequently Asked Questions</h5>
        <p>
          <strong>Is delivery discreet?</strong> Yes, all orders are shipped in
          plain packaging.<br />
          <strong>Is COD available?</strong> Yes, Cash on Delivery is available
          in most locations of {cityData.city}.<br />
          <strong>Are products genuine?</strong> Yes, all products are original
          and body-safe.
        </p>

        {/* H5 */}
        <h5>Order Sex Toys in {cityData.city} Today</h5>
        <p>
          Order today from LushDesire and enjoy premium adult wellness products
          with fast delivery, complete privacy, and peace of mind.
        </p>

        <p>
          <strong>LushDesire</strong> – Trusted Online Sex Toy Store in Uttar
          Pradesh.
        </p>
      </div>
    </>
  );
};

export default UttarPradesh;
